// ThemeContext.js
import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  useRef,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import {
  setOnlineUserStatus,
  setAccpetedUsers,
  setOnlineUsersList,
  setPendingUsersList,
  setTypingUsersList,
  setToastMessage,
  setMessagesList,
  setShowToaster,
  setLatestConversationsList,
  setUnseenMessages,
  setUnReadCount,
  setMessagesTime,
} from "../redux/slices/chatSlice";
import DASHBOARD_API from "../apis/dashboard.api";
import { websocketEventEmitter, getWs } from "./websocketConnect";
import moment from "moment";
import { setPlaidProcessingData } from "../redux/slices/financialAdvisorSlice";
// Create context
const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Get the initial theme from local storage or default to 'light'
  const [theme, setTheme] = useState(() => {
    return localStorage.getItem("theme") || "light";
  });
  let ws = getWs();

  const location = useLocation();
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  useEffect(() => {
    const excludedPaths = [
      "/login",
      "/sign-up",
      "/payment",
      "/trusteeLogin",
      "/acceptInvitation",
      "/forget-password",
      "/otpvalidation",
    ];
    if (
      !excludedPaths.includes(location.pathname) &&
      (isInitialLoad || location.pathname === "/dashboard")
    ) {
      console.log("calling chat websocket", isInitialLoad, location);
      getTotalUnreadMessages();
      getUsersList();
      // if (ws && ws.readyState !== WebSocket.OPEN) {
      //   console.log("calling chat websocket 22", isInitialLoad, location);
      //   connectAgain();
      // }
    }
    setIsInitialLoad(false);
  }, [location, isInitialLoad]);

  useEffect(() => {
    const excludedPaths = [
      "/login",
      "/sign-up",
      "/payment",
      "/trusteeLogin",
      "/acceptInvitation",
      "/forget-password",
      "/otpvalidation",
      "/questioner",
      "/free-trial"
    ];
    if (!excludedPaths.includes(location.pathname)) {
      getTotalUnreadMessages();
      if (ws && ws.readyState !== WebSocket.OPEN) {
        connectAgain();
      }
    }
  }, [location]);
  console.log("WebSocket wssssssssss", ws)

  // Toggle theme function
  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === "light" ? "dark" : "light"));
  };

  // Store the theme in local storage whenever it changes
  useEffect(() => {
    localStorage.setItem("theme", theme);
  }, [theme]);

  const isUserOnline = useSelector(
    (state) => state.rootReducer.chatInfo.onlineUserStatus
  );
  const messages = useSelector(
    (state) => state.rootReducer.chatInfo.messagesList
  );
  const onlineUsers = useSelector(
    (state) => state.rootReducer.chatInfo.onlineUsersList
  );
  const typingUsers = useSelector(
    (state) => state.rootReducer.chatInfo.typingUsersList
  );
  const pendingUsers = useSelector(
    (state) => state.rootReducer.chatInfo.pendingUsersList
  );
  const users = useSelector(
    (state) => state.rootReducer.chatInfo.accpetedUsersList
  );
  const latestConversationsList = useSelector(
    (state) => state.rootReducer.chatInfo.latestConversationsList
  );
  const unseenMessagesList = useSelector(
    (state) => state.rootReducer.chatInfo.unseenMessages
  );
  const messagesTimeList = useSelector(
    (state) => state.rootReducer.chatInfo.messagesTime
  );
  const plaidProcessingData = useSelector(
    (state) => state.rootReducer.financialAdvisor.plaidProcessingData
  );
  const currentUser =
    localStorage.getItem("userData") != "undefined" &&
    JSON.parse(localStorage.getItem("userData") || null);

  const onlineUsersRef = useRef(onlineUsers);
  const pendingUsersRef = useRef(pendingUsers);
  const acceptedUsersRef = useRef(users);
  const latestConversationsRef = useRef(latestConversationsList);
  const messagesRef = useRef(messages);
  const typingRef = useRef(typingUsers);
  const unSeenRef = useRef(unseenMessagesList);
  const messagesTimeListRef = useRef(messagesTimeList);
  const plaidProcessingDataRef = useRef(plaidProcessingData);

  useEffect(() => {
    messagesTimeListRef.current = messagesTimeList;
  }, [messagesTimeList]);

  useEffect(() => {
    typingRef.current = typingUsers;
  }, [typingUsers]);

  useEffect(() => {
    onlineUsersRef.current = onlineUsers;
  }, [onlineUsers]);

  useEffect(() => {
    pendingUsersRef.current = pendingUsers;
  }, [pendingUsers]);

  useEffect(() => {
    acceptedUsersRef.current = users;
  }, [users]);

  useEffect(() => {
    latestConversationsRef.current = latestConversationsList;
  }, [latestConversationsList]);

  useEffect(() => {
    unSeenRef.current = unseenMessagesList;
  }, [unseenMessagesList]);

  useEffect(() => {
    messagesRef.current = messages;
  }, [messages]);

  useEffect(() => {
    plaidProcessingDataRef.current = plaidProcessingData;
  }, [plaidProcessingData]);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [allUsers, setAllUsers] = useState([]);


  // const ws = useRef(null);

  const allUsersRef = useRef(allUsers);
  const getUsersList = async () => {
    try {
      setLoading(true);
      const data = await DASHBOARD_API.fetchUserList();
      if (data && data.data) {
        setAllUsers(data.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getTotalUnreadMessages = async () => {
    try {
      setLoading(true);
      const data = await DASHBOARD_API.fetchUnReadChatsCount();
      if (data && data.unreadCount) {
        dispatch(setUnReadCount(data.unreadCount));
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    allUsersRef.current = allUsers; // Keep the ref updated
  }, [allUsers]);
  // useEffect(() => {
  //   getUsersList();
  //   getTotalUnreadMessages();
  // }, []);
  const handleShowToast = () => {
    dispatch(setShowToaster(true));
    setTimeout(() => {
      dispatch(setShowToaster(false));
    }, 3000); // Hide after 3 seconds
  };
  // useEffect(() => {
  //   if(ws){
  //   if (!isUserOnline) {
  //     if(ws && ws.readyState === WebSocket.OPEN){
  //       ws.onopen = () => {
  //         console.log("Connected to WebSocket server heree");
  //         dispatch(setOnlineUserStatus(true));
  //       };
  //     }
  //   }

  //   ws.onmessage = (event) => {
  //     const data = JSON.parse(event.data);
  //     console.log("onmessage event.data", data);

  //     switch (data.action) {
  //       case "INVITED":
  //         handleInvite(data);
  //         break;
  //       case "INVITE_ACCEPTED":
  //         handleInviteAccepted(data);
  //         break;
  //       case "USER_ONLINE":
  //         handleUserOnline(data);
  //         break;
  //       case "USER_OFFLINE":
  //         handleUserOffline(data);
  //         break;
  //       case "USER_TYPING":
  //         handleUserTyping(data);
  //         break;
  //       case "USER_NOT_TYPING":
  //         handleUserNotTyping(data);
  //         break;
  //       case "MESSAGE":
  //         handleMessage(data);
  //         break;
  //       case "MSG_SENT":
  //         handleMsgSent(data);
  //         break;
  //       case "MSG_READ":
  //         handleMsgRead(data);
  //         break;
  //       case "MSG_DELIVERED":
  //         handleMsgDelivered(data);
  //         break;
  //       default:
  //         console.log("Unhandled action:", data.action);
  //         break;
  //     }
  //   };

  //   }

  //   return () => {
  //     if (ws) {
  //       ws.close();
  //     }
  //   };
  // }, []);

  useEffect(() => {
    console.log("WebSocket instance:", ws);

    if (ws) {
      if (ws.readyState === WebSocket.OPEN) {
        console.log("WebSocket is already open");
        dispatch(setOnlineUserStatus(true));
      } else {
        ws.onopen = () => {
          console.log("WebSocket connection opened");
          dispatch(setOnlineUserStatus(true));
        };
      }

      const messageHandler = (event) => {
        const data = event.detail; // Access data from the custom event
        console.log("Received WebSocket message in App:", data);

        switch (data.action) {
          case "INVITED":
            handleInvite(data);
            break;
          case "INVITE_ACCEPTED":
            handleInviteAccepted(data);
            break;
          case "INVITE_CANCEL_CONFIRMED":
            handleCancelInvite(data);
            break;
          case "INVITE_CANCELLED":
            handleCancelInvite(data);
            break;
          case "USER_ONLINE":
            handleUserOnline(data);
            break;
          case "USER_OFFLINE":
            handleUserOffline(data);
            break;
          case "USER_TYPING":
            handleUserTyping(data);
            break;
          case "USER_NOT_TYPING":
            handleUserNotTyping(data);
            break;
          case "MESSAGE":
            handleMessage(data);
            break;
          case "MSG_SENT":
            handleMsgSent(data);
            break;
          case "MSG_READ":
            handleMsgRead(data);
            break;
          case "MSG_DELIVERED":
            handleMsgDelivered(data);
            break;
          case "PLAID PROCESSING":
            handlePlaidProcessing(data);
            break;
          default:
            console.log("Unhandled action:", data.action);
            break;
        }
      };

      websocketEventEmitter.addEventListener("websocket-message", messageHandler);

      return () => {
        websocketEventEmitter.removeEventListener(
          "websocket-message",
          messageHandler
        );
        if (ws) {
          ws.close();
        }
      };
    }
  }, [ws, dispatch]);


  const handleInvite = (data) => {
    const parsedUser = JSON.parse(data.message);
    const findUser =
      allUsersRef.current &&
      allUsersRef.current.find((user) => user.id === +parsedUser.senderId);
    const toastMessage = `${findUser ? findUser.name : "Someone"} Invited You`;
    dispatch(setToastMessage(toastMessage));
    handleShowToast();

    const newUser = {
      ...parsedUser,
      // userOnlineId:
      //   parsedUser.receiverId && parsedUser.receiverId !== currentUser.id
      //     ? parsedUser.receiverId // Use ReceiverUser's name if currentUser.id does not match receiverId
      //     : parsedUser.senderId && parsedUser.senderId !== currentUser.id
      //     ? parsedUser.senderId // Use SenderUser's name if currentUser.id does not match senderId
      //     : "",
      name: findUser ? findUser.name : "",
    };
    dispatch(setPendingUsersList([...pendingUsersRef.current, newUser]));
  };

  const handleInviteAccepted = (data) => {
    const parsedUser = JSON.parse(data.message);
    const acceptedUserId = parsedUser.receiverId || parsedUser.senderId;
    const findUser =
      allUsersRef.current &&
      allUsersRef.current.find((user) => user.id === +acceptedUserId);
    const toastMessage = `${findUser ? findUser.name : "Someone"
      } Accepted Your Invite`;
    dispatch(setToastMessage(toastMessage));
    handleShowToast();

    const updatedPendingUsers = pendingUsersRef.current.filter(
      (user) => user.id !== parsedUser.id || parsedUser.conversationId
    );
    dispatch(setPendingUsersList(updatedPendingUsers));

    const newUser = {
      ...parsedUser,
      userOnlineId:
        parsedUser.receiverId && parsedUser.receiverId !== currentUser.id
          ? parsedUser.receiverId
          : parsedUser.senderId && parsedUser.senderId !== currentUser.id
            ? parsedUser.senderId
            : "",
      name: findUser ? findUser.name : "",
    };
    dispatch(setAccpetedUsers([...acceptedUsersRef.current, newUser]));
  };

  const handleCancelInvite = (data) => {
    const parsedUser = JSON.parse(data.message);
    const cancelledUserId = parsedUser.senderId || parsedUser.receiverId;
    // Find user in all users list for toast
    const parsedUserNew = pendingUsersRef.current.find(
      (user) => user.id === parsedUser.conversationId
    );
    const findUser =
      allUsersRef.current &&
      allUsersRef.current.find((user) => user.id === +cancelledUserId);
    // if(currentUser.id !== findUser.id){
    const toastMessage = `${parsedUser.senderId === null ? parsedUserNew.name : (findUser ? findUser.name : "Someone")
      } cancelled or declined your invite`;
    dispatch(setToastMessage(toastMessage));
    handleShowToast();
    // }

    // Remove only from pending users
    const updatedPendingUsers = pendingUsersRef.current.filter(
      (user) => user.id !== parsedUser.conversationId
    );
    dispatch(setPendingUsersList(updatedPendingUsers));

    // ❌ Do NOT add them to accepted users here
  };
  //  const handleCancelInviteConfirm = (data) => {
  //   const parsedUser = JSON.parse(data.message);
  //   const cancelledUserId =  parsedUser.senderId || parsedUser.receiverId;
  //   // Find user in all users list for toast
  //   const findUser =
  //     allUsersRef.current &&
  //     allUsersRef.current.find((user) => user.id === +cancelledUserId);
  //     console.log("finsssssss confrirm",findUser,parsedUser,currentUser.id)
  //   if(currentUser.id !== findUser.id && parsedUser.senderId !== currentUser.id){
  //       const toastMessage = `${
  //         findUser ? findUser.name : "Someone"
  //       } cancelled or declined your invite`;
  //       dispatch(setToastMessage(toastMessage));
  //       handleShowToast();
  //     }

  //     // Remove only from pending users
  //     const updatedPendingUsers = pendingUsersRef.current.filter(
  //       (user) => user.receiverId !== cancelledUserId
  //     );
  //     dispatch(setPendingUsersList(updatedPendingUsers));

  //   // ❌ Do NOT add them to accepted users here
  // };


  const handleUserOnline = (data) => {
    const parsedMessage = JSON.parse(data.message);
    const userId = parsedMessage.userId;
    dispatch(setOnlineUsersList([...onlineUsersRef.current, userId]));
  };

  const handleUserOffline = (data) => {
    const parsedMessage = JSON.parse(data.message);
    const userId = parsedMessage.userId;
    const updatedOnlineUsers = onlineUsersRef.current.filter(
      (onlineUserId) => onlineUserId !== userId
    );
    dispatch(setOnlineUsersList(updatedOnlineUsers));

    const updatedAcceptedUsers =
      acceptedUsersRef.current &&
      acceptedUsersRef.current.map((user) => {
        if (user.senderId === userId || user.receiverId === userId) {
          return {
            ...user,
            userLastSeen: moment.utc().format("YYYY-MM-DDTHH:mm:ss.SSS[Z]"),
          };
        }
        return user;
      });
    dispatch(setAccpetedUsers(updatedAcceptedUsers));
  };

  const handleUserTyping = (data) => {
    const parsedTyping =
      typeof data.conversation === "string"
        ? JSON.parse(data.conversation)
        : data.conversation;
    const newTypingUser = { ...parsedTyping, userId: data ? data.userId : "" };
    dispatch(setTypingUsersList([...typingRef.current, newTypingUser]));
  };

  const handleUserNotTyping = (data) => {
    const parsedTyping =
      typeof data.conversation === "string"
        ? JSON.parse(data.conversation)
        : data.conversation;
    const newTypingUser = { ...parsedTyping, userId: data ? data.userId : "" };

    const updatedTypingUsers =
      typingRef &&
      typingRef.current.filter((user) => user.userId !== newTypingUser.userId);
    dispatch(setTypingUsersList(updatedTypingUsers));
  };

  const handleMessage = (data) => {
    const parsedMessage = JSON.parse(data.conversation);
    const conversation = {
      ...parsedMessage.conversation,
      message: parsedMessage.message.message,
      conversationId: parsedMessage.conversation.id,
      id: parsedMessage.message.id,
      updatedAt: parsedMessage.message.sentTime,
      status: parsedMessage.message.status,
    };
    sendMsgDelivered([parsedMessage.message.id]);

    dispatch(
      setMessagesTime(
        messagesTimeListRef.current &&
        messagesTimeListRef.current
          .map((message) =>
            message.conversationId === parsedMessage.conversation.id
              ? {
                ...message,
                updatedAt: parsedMessage.message.sentTime,
              }
              : message
          )
          .concat(
            messagesTimeListRef.current.some(
              (message) =>
                message.conversationId === parsedMessage.conversation.id
            )
              ? []
              : {
                conversationId: parsedMessage.conversation.id,
                updatedAt: parsedMessage.message.sentTime,
              }
          )
      )
    );
    const chatMessage = {
      message: parsedMessage.message.message,
      receiver_id: currentUser.id,
      conversationId: parsedMessage.conversation.id,
      sender_id: parsedMessage.message.senderId,
      senderId: parsedMessage.message.senderId,
      id: parsedMessage.message.id,
      status: parsedMessage.message.status,
    };
    dispatch(setMessagesList([...messagesRef.current, chatMessage]));
    dispatch(
      setLatestConversationsList([
        ...latestConversationsRef.current,
        conversation,
      ])
    );

    dispatch(setUnseenMessages([...unSeenRef.current, conversation]));
  };

  const handleMsgSent = (data) => {
    const parsedMessage =
      typeof data.data === "string" ? JSON.parse(data.conversation) : data.data;
    const serverMessage = {
      senderId: parsedMessage.senderId,
      id: parsedMessage.id,
      uuid: parsedMessage.uuid,
      message: parsedMessage.message,
      conversationId: parsedMessage.conversationId,
      updatedAt: parsedMessage.sentTime,
      status: parsedMessage.status,
    };

    const arr = [...messagesRef.current, serverMessage];
    const messageExists =
      arr && arr.some((msg) => msg.uuid === serverMessage.uuid);

    if (messageExists) {
      const updatedMessages = messagesRef.current.map((msg) =>
        msg.uuid === serverMessage.uuid ? { ...msg, ...serverMessage } : msg
      );
      if (!updatedMessages.some((msg) => msg.uuid === serverMessage.uuid)) {
        updatedMessages.push(serverMessage);
      }
      dispatch(setMessagesList(updatedMessages));
    }
    // else {
    //   dispatch(setMessagesList([...messagesRef.current, serverMessage]));
    // }

    dispatch(
      setLatestConversationsList([
        ...latestConversationsRef.current,
        serverMessage,
      ])
    );
  };

  const handleMsgRead = (data) => {
    const parsedMessage = data.data && data.data;
    const parsedMessageIds = new Set(parsedMessage.map((msg) => msg.id));

    const updatedMessages = messagesRef.current.map((msg) =>
      parsedMessageIds.has(msg.id) ? { ...msg, status: "READ" } : msg
    );

    dispatch(setMessagesList(updatedMessages));
  };

  const handlePlaidProcessing = (data) => {
    // console.log("handlePlaidProcessing data", data);

    // Parse the incoming message
    const parsedMessage = typeof data.message === "string"
      ? JSON.parse(data.message)
      : data.message;

    const { userId, progress } = parsedMessage;

    // Get current plaidProcessingData from ref
    const currentPlaidData = plaidProcessingDataRef.current;

    let updatedPlaidData;

    // If progress is 100%, remove the entry from the array
    if (progress >= 100) {
      updatedPlaidData = currentPlaidData.filter(
        (item) => item.userId !== userId
      );
    } else {
      // Check if userId already exists in the array
      const existingIndex = currentPlaidData.findIndex(
        (item) => item.userId === userId
      );

      if (existingIndex !== -1) {
        // Update existing entry with new progress
        updatedPlaidData = currentPlaidData.map((item, index) =>
          index === existingIndex ? { ...item, progress } : item
        );
      } else {
        // Add new entry
        updatedPlaidData = [...currentPlaidData, { userId, progress }];
      }
    }

    // Dispatch updated array to Redux
    dispatch(setPlaidProcessingData(updatedPlaidData));
  };

  const handleMsgDelivered = (data) => {
    const parsedMessage = data.data && data.data;
    const parsedMessageIds = new Set(parsedMessage.map((msg) => msg.id));

    const updatedMessages = messagesRef.current.map((msg) =>
      parsedMessageIds.has(msg.id) ? { ...msg, status: "DELIVERED" } : msg
    );

    dispatch(setMessagesList(updatedMessages));
  };

  const sendMsgDelivered = (ids) => {
    if (ws && ws.readyState === WebSocket.OPEN) {
      console.log("calling sending action delivered", ids);
      ws.send(
        JSON.stringify({
          action: "delivered",
          ids: ids,
        })
      );
    }
  };

  const connectAgain = () => {
    ws = getWs();
  };
  return (
    <ThemeContext.Provider value={{ theme, toggleTheme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// Custom hook to use the theme context
export const useTheme = () => useContext(ThemeContext);
